module.exports = __webpack_public_path__ + "static/media/apple-alt.177e042a.svg";